if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }

      get successful() {
        return this.querySelector('.alert--success') !== null;
      }

      get sessionKey() {
        return 'screenmate:newsletter-popup-shown';
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1, true);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay, force = false) {
        if (Shopify.designMode) return;

        this.forceShow = force;
        this.activeSeconds = 0;

        // Count only seconds in which the storefront tab is visible.
        this.activeTimer = setInterval(() => {
          if (document.hidden) return;

          this.activeSeconds += 1;
          if (this.activeSeconds >= delay) {
            this.requestShow(force);
          }
        }, 1000);

        // Reaching 50% scroll depth is an alternative high-intent trigger.
        this.scrollHandler = () => {
          const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
          if (scrollableHeight > 0 && window.scrollY / scrollableHeight >= 0.5) {
            this.requestShow(force);
          }
        };

        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        this.scrollHandler();

        // Exit intent only applies to desktop-class pointers, never to touch devices.
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.exitIntentHandler = (event) => {
            if (event.clientY <= 0 && !event.relatedTarget) {
              this.requestShow(force);
            }
          };

          document.addEventListener('mouseout', this.exitIntentHandler);
        }
      }

      requestShow(force = false) {
        this.clearTriggers();

        if (!force && this.wasShownThisSession()) return;

        const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!customerPrivacy) {
          this.privacyAttempts = (this.privacyAttempts || 0) + 1;
          if (this.privacyAttempts <= 20) {
            this.privacyTimer = setTimeout(() => this.requestShow(force), 250);
            return;
          }
        }

        if (customerPrivacy && customerPrivacy.shouldShowBanner()) {
          if (this.waitingForConsent) return;

          this.waitingForConsent = true;
          document.addEventListener('visitorConsentCollected', () => {
            this.waitingForConsent = false;
            this.requestShow(force);
          }, { once: true });
          return;
        }

        this.markShownThisSession();
        this.show();
      }

      clearTriggers() {
        if (this.activeTimer) {
          clearInterval(this.activeTimer);
          this.activeTimer = null;
        }

        if (this.privacyTimer) {
          clearTimeout(this.privacyTimer);
          this.privacyTimer = null;
        }

        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler);
          this.scrollHandler = null;
        }

        if (this.exitIntentHandler) {
          document.removeEventListener('mouseout', this.exitIntentHandler);
          this.exitIntentHandler = null;
        }
      }

      wasShownThisSession() {
        try {
          return window.sessionStorage.getItem(this.sessionKey) === 'true';
        }
        catch (error) {
          return this.dataset.shownThisSession === 'true';
        }
      }

      markShownThisSession() {
        try {
          window.sessionStorage.setItem(this.sessionKey, 'true');
        }
        catch (error) {
          this.dataset.shownThisSession = 'true';
        }
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.successful ? 180 : this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
